/* Collezioni a schede: cambio scheda e linea oro che scorre */
(function () {
  document.querySelectorAll('[data-ap-tabelle]').forEach(function (s) {
    var tabs = s.querySelectorAll('[data-ap-tab]'), linea = s.querySelector('[data-ap-linea]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.dataset.apTab;
        tabs.forEach(function (x) { x.classList.toggle('is-on', x === t); x.setAttribute('aria-selected', x === t); });
        s.querySelectorAll('[data-ap-pan]').forEach(function (p) { p.hidden = p.dataset.apPan !== i; });
        if (linea) linea.style.transform = 'translateX(' + (i * 100) + '%)';
      });
    });
  });
})();
